import { useEffect } from 'react';
import { useLocation } from 'react-router-dom';
import { pageView } from './ga';

export const useGA = (): void => {
  const location = useLocation();

  useEffect(() => {
    pageView(location.pathname);
  }, [location]);
};
